import askSlotsUrl from './modal-ask-slots.html';

export default class AskSlotsService {
  constructor($uibModal) {
    'ngInject';

    Object.assign(this, { $uibModal });
  }

  ask(slots = 1, type = 'primary') {
    return this.$uibModal.open({
      templateUrl: askSlotsUrl,
      controllerAs: 'ctrl',
      size: '620',
      controller() {
        this.slots = slots;
        this.type = type;
      },
    }).result;
  }
}
